import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <Compass size={28} style={{ color: "var(--cyan)", marginBottom: 8 }} />
        <h1 style={{ marginTop: 0 }}>404</h1>
        <p className="hint">This surface doesn't exist yet.</p>
        <Link to="/focus" className="btn primary" style={{ marginTop: 12 }}>Back to FocusLinc</Link>
      </div>
    </div>
  );
}
